import React from "react";
import { motion } from "framer-motion";

const cardReveal = {
  hidden: { opacity: 0, y: 64, scale: 0.985, filter: "blur(8px)" },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.82,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const imageReveal = {
  hidden: { opacity: 0, y: 88, scale: 0.96, rotate: -1.5, filter: "blur(10px)" },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    rotate: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.95,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.08,
    },
  },
};

const cardViewport = {
  amount: 0.22,
  once: false,
  margin: "-140px 0px -10% 0px",
};

const Sectionremedart = () => {
  const steps = [
    {
      id: 1,
      title: "Proactive Health, Tracked Daily.",
      desc: "Traditional care waits for your next monthly clinic visit. We don’t. Our intelligent dashboard tracks your daily vitals, symptoms, and baby’s milestones. It acts as a silent, AI-powered guardian—analyzing your data to catch potential risks early, so you can focus on the joy of pregnancy, not the anxiety of the unknown.",
      img: "/screen1.png",
      bgColor: "#ffffff"
    },
    {
      id: 2,
      title: "Your Entire Journey, Masterfully Organized.",
      desc: "Say goodbye to carrying messy files. Every lab report, prescription, and personalized wellness plan from your 9-expert team lives right here. From routine doctor consults and daily tracking to instant emergency support, every detail of your care is managed right at your fingertips. Behind the screen, your circle of 9 medical experts is fully synced on this single platform. They share real-time updates with each other, meaning you never have to repeat your medical history. It’s absolute convenience and cohesive care, built perfectly for your busy life.",
      img: "/screen2.png",
      bgColor: "#fffafa"
    },
    {
      id: 3,
      title: "24/7 Reassurance, Just a Tap Away.",
      desc: "Midnight doubts and sudden cramps don’t follow standard clinic hours. Whether it’s an emergency or a simple question about your diet, your medical team is always in your pocket. It’s the clinical authority of a top-tier hospital, delivered with the warmth of a personal companion—whenever you need it most.",
      img: "/screen3.png",
      bgColor: "#f8fbff"
    },
  ];

  return (
    <div className="full-width-stack-container" style={{ position: "relative" }}>

      {steps.map((step) => (
        <section
          key={step.id}
          className="full-page-section"
          style={{ backgroundColor: step.bgColor, zIndex: step.id }}
        >
          <div className="container h-100 stack-card-shell">
            <div className="row h-100 align-items-center stack-card-row">
              <div className="col-md-6 px-lg-5 content-side" style={{ position: "relative", zIndex: 2 }}>
                <div className="vertical-scroll-bar"></div>

                <motion.div
                  className="stack-card-copy"
                  variants={cardReveal}
                  initial="hidden"
                  whileInView="visible"
                  viewport={cardViewport}
                >
                  <h2 className="proactive-title">
                    {step.title.includes(",") ? (
                      <>
                        {step.title.split(",")[0].trim()}, <br />
                        <span className="pink-text">{step.title.split(",").slice(1).join(",").trim()}</span>
                      </>
                    ) : (
                      step.title
                    )}
                  </h2>

                  <p className="step-desc mt-4">{step.desc}</p>
                  <div className="hindi-caption-wrapper mt-5">
                    <img src="/TabB.png" className="pink-arrow" alt="" />
                    <img src="/awroR.png" className="pink-arrow-pointer" alt="" />
                    <span className="hindi-text">"सिर्फ एक सफ़र नहीं, एक खूबसूरत उत्सव"</span>
                  </div>
                </motion.div>
              </div>

              <div className="col-md-6 image-side" style={{ zIndex: 2 }}>
                <motion.div
                  className="tablet-container"
                  variants={imageReveal}
                  initial="hidden"
                  whileInView="visible"
                  viewport={cardViewport}
                >
                  <img src="/tabScreen.png" className="tablet-frame" alt="tablet" />
                  <div className="dashboard-display-wrapper">
                    <img src={step.img} className="dashboard-display-img" alt="dashboard" />
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Sectionremedart;
